<ion-select
  [label]="'unit.title' | translate"
  label-placement="floating"
  fill="outline"
  (ionChange)="selectedItemChanged.emit($event.detail.value)"
  [value]="preselectedItem"
  mode="md"
  required
  interface="popover"
>
  @for (item of this.items; track item) {
  <ion-select-option [value]="item">{{ item }}</ion-select-option>
  }
</ion-select>
